import { forwardRef, type HTMLAttributes } from 'react';

import { SIDEBAR_NAVIGATION_CONTENT_INSET_TOP } from '../sidebar-navigation-surface/index.css';

export const DocumentsPaneSurface = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(function DocumentsPaneSurface({ children, style, ...props }, ref) {
  return (
    <div
      {...props}
      data-documents-pane-host="true"
      ref={ref}
      style={{
        height: '100%',
        minHeight: 0,
        minWidth: 0,
        boxSizing: 'border-box',
        // LauncherSidebarLayout owns the inset in /all; portals own it here.
        paddingTop: `var(--sidebar-navigation-content-inset-top, ${SIDEBAR_NAVIGATION_CONTENT_INSET_TOP}px)`,
        ...style,
      }}
    >
      {children}
    </div>
  );
});
